import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import themes, { THEME_TYPES } from 'Styles/Themes';

import { ReactComponent as AddSVG } from '@Assets/Svgs/ic_add.svg';
import { ReactComponent as EditSVG } from '@Assets/Svgs/ic_edit.svg';
import Button from '@Components/Common/Button';
import TX from '@Components/Common/Text';

const AddingButton = ({ isProjectTagModalVisible, tags, handleProjectTagModalVisible }) => {
  const theme = themes[THEME_TYPES.LIGHT];

  return (
    <Container>
      <AddingButtonContainer>
        <Button
          isTextOnly={false}
          backgroundColor={theme.colors.ui_2}
          style={{ padding: '6px 12px 6px 6px', height: '28px' }}
          onClick={handleProjectTagModalVisible}
        >
          <AddIconWrapper>{tags.length ? <EditIcon /> : <AddIcon />}</AddIconWrapper>
          <TX.FootnoteM>{tags.length ? '태그 편집' : '태그 추가'}</TX.FootnoteM>
        </Button>
      </AddingButtonContainer>

      {isProjectTagModalVisible ? null : (
        <ProjectTagContainer>
          {tags.map(tag => (
            <ProjectTagText key={tag}># {tag}</ProjectTagText>
          ))}
        </ProjectTagContainer>
      )}
    </Container>
  );
};

AddingButton.propTypes = {
  isProjectTagModalVisible: PropTypes.bool.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleProjectTagModalVisible: PropTypes.func.isRequired,
};

const IconCSS = css`
  width: 16px;
  height: 16px;
`;

const FlexAlignCenterDiv = styled.div`
  display: flex;
  align-items: center;
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 6fr;

  margin-left: 20px;
  gap: 0px 12px;
`;

const StyledIconWrapper = styled(FlexAlignCenterDiv)`
  ${IconCSS}

  justify-content: center;
`;

const AddingButtonContainer = styled.div``;

const AddIconWrapper = styled(StyledIconWrapper)`
  margin-right: 8px;
`;

const AddIcon = styled(AddSVG)`
  stroke: ${({ theme }) => theme.colors.ui_on_3};
`;

const EditIcon = styled(EditSVG)`
  fill: ${({ theme }) => theme.colors.ui_on_3};
`;

const ProjectTagContainer = styled(FlexAlignCenterDiv)`
  display: flex;
  flex-wrap: wrap;

  gap: 4px;
`;

const ProjectTagText = styled(TX.FootnoteM)`
  color: ${({ theme }) => theme.colors.ui_on_3};
`;

export default AddingButton;
